import React from 'react';

const Footer = () => (
<footer className="footer">
	<p>Problems? Suggestions? Let us know on <a href="https://github.com/paleobot/pbot-dev/issues" target="_blank">Github</a></p>

</footer>
);

export default Footer;
